import type {LucideIcon} from 'lucide-react'
import {forwardRef, type ReactNode} from 'react'
import {Input, type InputProps} from '@/components/ui/input'
import {cn} from '@/lib/utils'

interface IconInputProps extends Omit<InputProps, 'size'> {
    icon: LucideIcon
    /** `sm` = h-8, `default` = h-10. Default: `default`. */
    inputSize?: 'sm' | 'default'
    /** Match an adjacent element on the left (removes left radius + ensures seam). */
    joinedLeft?: boolean
    /** Fixed width utility (e.g. `w-64`). Otherwise fills container. */
    widthClass?: string
    /** Slot rendered absolute-right, e.g. a clear button. */
    trailing?: ReactNode
}

export const IconInput = forwardRef<HTMLInputElement, IconInputProps>(function IconInput(
    {icon: Icon, inputSize = 'default', joinedLeft, widthClass, trailing, className, ...inputProps},
    ref,
) {
    return (
        <div className={cn('relative', widthClass)}>
            <Icon className="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none"/>
            <Input
                ref={ref}
                size={inputSize}
                className={cn('pl-7', trailing && 'pr-7', joinedLeft && 'rounded-l-none', className)}
                {...inputProps}
            />
            {trailing}
        </div>
    )
})
